// extracted by mini-css-extract-plugin
export var category = "_kl-9";
export var categoryHeader = "_kl-e";
export var container = "_kl-0";
export var group = "_kl-a";
export var groupItems = "_kl-f";
export var groupSeparator = "_kl-j";
export var loading = "_kl-1";
export var noResults = "_kl-3";
export var placeholder = "_kl-2";
export var resultContent = "_kl-5";
export var resultIcon = "_kl-c";
export var resultItem = "_kl-g";
export var resultMeta = "_kl-8";
export var resultSubtitle = "_kl-7";
export var resultSuffix = "_kl-i";
export var resultTitle = "_kl-6";
export var resultsList = "_kl-4";
export var searchGroup = "_kl-d";
export var selected = "_kl-h";
export var subgroup = "_kl-b";